var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_876_430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4785 20.5477L22.5128 34.2462M20.6217 22.3961L34.3696 32.3978M47.2569 24.3162C48.9976 35.2239 41.5613 45.4456 30.6475 47.147C19.7336 48.8484 9.47503 41.3853 7.73433 30.4776C5.99363 19.57 13.43 9.34826 24.3438 7.64684C35.2577 5.94542 45.5163 13.4086 47.2569 24.3162Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_876_430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "matrix(0.988065 -0.154035 0.157591 0.987505 0 7.39368)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXForm);
export default __webpack_public_path__ + "static/media/X-form.c07edb335ff6a90a062ae3b6a02bed49.svg";
export { ForwardRef as ReactComponent };